import React, { useState } from "react"


export default function Userform(props) {

    //   const intialSubFormData = Object.freeze({ areYouComfortable: '', whatHappened: '', beforeIncident: [], duringIncident: [], afterIncident: [], physicalLocation: '', digitalLocation: '', dateOfIncident: '', timeOfIncident: '', presentCharacteristics: [], drugs: '', solutions: [] })
    const intialFormData = Object.freeze({ firstName: '', lastName: '', email: '', contact: '', typeOfWork: '', locationOfWork: '', addedBy: '', status: '', id: '1', data: { areYouComfortable: '', whatHappened: '', beforeIncident: [], duringIncident: [], afterIncident: [], physicalLocation: '', digitalLocation: '', dateOfIncident: '', timeOfIncident: '', presentCharacteristics: [], Conflict: [], drugs: '', solutions: [] } })
    const [userFormData, updateUserFormData] = React.useState(intialFormData);

    const handleChangeUserForm = (e) => {
        if (e.target.name == "firstName" || e.target.name == "lastName") {
            console.log("capitals")
            console.log(e.target.name)
            updateUserFormData({
                ...userFormData,
                [e.target.name]: capitalizeFirstLetter(e.target.value)
            });
        }else if (e.target.name == "email") {
            console.log(e.target.name)
            updateUserFormData({
                ...userFormData,
                [e.target.name]: e.target.value.toLowerCase()
            });
        } else {
            updateUserFormData({
                ...userFormData,
                [e.target.name]: e.target.value
            });
        }
    };

    // first letter capital
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }



    const popupUserFormClose = () => {
        props.popupClose();
    }

    const handleSubmitUserForm = (e) => {
        e.preventDefault()
        props.onSubmit(userFormData)
        console.log(userFormData);
    };

    return (
        <>
            <form onSubmit={handleSubmitUserForm}>
                <div className="mt-3 text-center">
                    <div className="grid grid-cols-12 gap-2 md:gap-5 my-2">
                        <div className="sm:col-span-12 md:col-span-4 col-span-full">
                            <label
                                htmlFor="firstName"
                                className="block text-[1.1rem] font-semibold text-gray-600"
                            >
                                First Name
                            </label>
                            <div className="mt-2 relative rounded-md shadow-sm">
                                <input required onChange={handleChangeUserForm}
                                    type="text"
                                    name="firstName"
                                    id="firstName"
                                    value={userFormData.firstName}
                                    className="text-gray-700 mt-2 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-[1.1rem]"
                                />
                            </div>
                        </div>
                        <div className="md:col-span-4 col-span-full">
                            <label
                                htmlFor="lastName"
                                className="block text-[1.1rem] font-semibold text-gray-600"
                            >
                                Surname
                            </label>
                            <div className="mt-2 relative rounded-md shadow-sm">
                                <input required onChange={handleChangeUserForm}
                                    type="text"
                                    name="lastName"
                                    id="lastName"
                                    value={userFormData.lastName}
                                    className="text-gray-700 mt-2 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-[1.1rem]"
                                />
                            </div>
                        </div>
                        <div className="md:col-span-4 col-span-full">
                            <label
                                htmlFor="email"
                                className="block text-[1.1rem] font-semibold text-gray-600"
                            >
                                Email Address
                            </label>
                            <div className="mt-2 relative rounded-md shadow-sm">
                                <input required onChange={handleChangeUserForm}
                                    type="email"
                                    name="email"
                                    id="email"
                                    value={userFormData.email}
                                    className="text-gray-700 mt-2 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-[1.1rem]"
                                />
                            </div>
                        </div>
                        <div className="md:col-span-4 col-span-full">
                            <label
                                htmlFor="contact"
                                className="block text-[1.1rem] font-semibold text-gray-600"
                            >
                                Contact Number
                            </label>
                            <div className="mt-2 relative rounded-md shadow-sm">
                                <input onChange={handleChangeUserForm}
                                    type="tel"
                                    name="contact"
                                    id="contact"
                                    value={userFormData.contact}
                                    className="text-gray-700 mt-2 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-[1.1rem]"
                                />
                            </div>
                        </div>
                        <div className="md:col-span-4 col-span-full">
                            <label
                                htmlFor="typeOfWork"
                                className="block text-[1.1rem] font-semibold text-gray-600"
                            >
                                Type of work
                            </label>
                            <div className="mt-2 relative rounded-md shadow-sm">
                                <select onChange={handleChangeUserForm}
                                    name="typeOfWork"
                                    id="typeOfWork"
                                    value={userFormData.typeOfWork}
                                    className="text-gray-700 mt-2 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-[1.1rem]"
                                >
                                    <option value="" />
                                    <option value="Volunteer">Volunteer</option>
                                    <option value="Employee">Employee</option>
                                    <option value="Both above">Both above</option>
                                    <option value="External">External</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </div>
                        <div className="md:col-span-4 col-span-full">
                            <label
                                htmlFor="locationOfWork"
                                className="block text-[1.1rem] font-semibold text-gray-600"
                            >
                                Location of work
                            </label>
                            <div className="mt-2 relative rounded-md shadow-sm">
                                <select onChange={handleChangeUserForm}
                                    name="locationOfWork"
                                    id="locationOfWork"
                                    value={userFormData.type}
                                    className="text-gray-700 mt-2 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-[1.1rem]"
                                >
                                    <option value="" />
                                    <option value="Volunteer Leadership">
                                        Volunteer Leadership
                                    </option>
                                    <option value="Community Operations">
                                        Community Operations
                                    </option>
                                    <option value="Resources">Resources</option>
                                    <option value="Education and Enterprise">
                                        Education and Enterprise
                                    </option>
                                    <option value="Engagement and Experience">
                                        Engagement and Experience
                                    </option>
                                    <option value="Digital and Intelligence">
                                        Digital and Intelligence
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-end">
                    <button
                        id="addPersonDetails"
                        type="submit"
                        className="px-5 py-2 m-2 bg-green-600 hover:bg-green-800 text-white cursor-pointer rounded-md"
                    >
                        Add
                    </button>
                    <button
                        onClick={popupUserFormClose}
                        id="closePerson"
                        type="button"
                        className="px-5 py-2 m-2 bg-red-500 hover:bg-red-700 text-white cursor-pointer rounded-md"
                    >
                        Close
                    </button>
                </div>
            </form>
        </>
    )
};